<template>
  <div class="px-0">
    <v-card-title class="text-center justify-center py-6">
      <h1 class="font-weight-bold text-h4">
        <span style="color: black">
          {{ mainTitle }}
        </span>
      </h1>
    </v-card-title>
    <v-card-subtitle class="text-center justify-center pb-6">
      <span class="text-body-1" style="color: black">
        {{ subTitle }}
      </span>
    </v-card-subtitle>
    <!-- Tab Switcher Buttons -->
    <div class="d-flex justify-center mb-6">
      <v-btn-toggle v-model="activeTab" mandatory>
        <v-btn
          :value="0"
          class="text-none"
          :class="activeTab === 0 ? 'white--text' : ''"
          :color="activeTab === 0 ? 'error' : ''"
          :text="activeTab === 1 ? true : false"
        >
          <v-icon :class="activeTab === 0 ? 'white--text' : ''" left>mdi-tag-edit</v-icon>
          Manual Entry
        </v-btn>
        <v-btn
          :value="1"
          class="text-none"
          w
          :class="activeTab === 1 ? 'white--text' : ''"
          :color="activeTab === 1 ? 'error' : ''"
          :text="activeTab === 0 ? true : false"
        >
          <v-icon :class="activeTab === 1 ? 'white--text' : ''" left>mdi-file-upload</v-icon>
          Bulk Import
        </v-btn>
      </v-btn-toggle>
    </div>
    <!--statistics card-->
    <v-row v-if="hasAnyProducts && activeTab === 0" class="justify-center">
      <v-col cols="12" md="8">
        <v-card elevation="0" outlined color="#26c6da">
          <v-card-text class="white--text">
            <!-- <div class="text-h6 font-weight-bold mb-4 text-center">
              <v-icon color="white" class="mr-2">mdi-chart-bar</v-icon>
              Match Statistics
            </div> -->
            <v-row>
              <v-col cols="4" class="text-center">
                <div class="text-h4 font-weight-bold">
                  {{ totalProducts + previewTotalProducts }}
                </div>
                <div class="text-caption">Total Products</div>
                <v-icon color="white" class="mt-1">mdi-package-variant</v-icon>
              </v-col>
              <v-col cols="4" class="text-center">
                <div class="text-h4 font-weight-bold">
                  {{ totalCompetitors + previewTotalCompetitors }}
                </div>
                <div class="text-caption">Total Competitors</div>
                <v-icon color="white" class="mt-1">mdi-store</v-icon>
              </v-col>
              <v-col cols="4" class="text-center">
                <div class="text-h4 font-weight-bold">{{ totalMatches + previewTotalMatches }}</div>
                <div class="text-caption">Total Matches</div>
                <v-icon color="white" class="mt-1">mdi-link-variant</v-icon>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Tab Content -->
    <div class="py-3">
      <!-- Single Product Tab -->
      <div v-if="activeTab === 0">
        <v-row class="justify-center">
          <v-col align-self="center" cols="12" md="8">
            <v-card class="px-10 pb-10" elevation="0">
              <v-card-title> Create New Product Match </v-card-title>
              <!-- Tracking List Summary Section -->
              <!-- <v-divider v-if="trackingList.length > 0"></v-divider> -->
              <v-card-text v-if="trackingList.length > 0" class="py-3">
                <div class="d-flex align-center mb-2">
                  <v-icon color="primary" class="mr-2">mdi-format-list-bulleted</v-icon>
                  <span class="text-subtitle-1 font-weight-medium">Products matchs configured</span>
                  <v-chip small color="primary" class="ml-2">{{ trackingList.length }}</v-chip>
                </div>
                <!-- Horizontal scrolling container -->
                <div class="tracking-list-scroll-container mb-5">
                  <div class="tracking-list-horizontal d-flex">
                    <div
                      v-for="(trackingItem, index) in trackingList"
                      :key="index"
                      class="tracking-item-wrapper flex-shrink-0 mr-3"
                    >
                      <v-card outlined class="tracking-item-card">
                        <v-card-text class="pa-2">
                          <div class="d-flex align-center">
                            <img
                              v-if="getFaviconUrl(trackingItem.mainProductUrl)"
                              :src="getFaviconUrl(trackingItem.mainProductUrl)"
                              width="20"
                              height="20"
                              class="favicon-icon mr-2"
                              @error="onFaviconError"
                            />
                            <v-icon v-else small color="grey" class="mr-2">mdi-chart-line</v-icon>

                            <div class="flex-grow-1 text-truncate">
                              <div class="text-body-2 font-weight-medium text-truncate">
                                <span class="mr-2">Product {{ index + 1 }}</span>
                                <v-chip v-if="trackingItem.eanSku" x-small color="primary">{{
                                  trackingItem.eanSku
                                }}</v-chip>
                              </div>
                              <div class="text-caption text--secondary text-truncate">
                                {{ extractDomain(trackingItem.mainProductUrl) }}
                              </div>
                              <div class="text-caption text--secondary">
                                + {{ trackingItem.matchsUrls.length }} competitors
                              </div>
                            </div>

                            <!-- Toggle button for matched URLs -->
                            <v-btn
                              v-if="trackingItem.matchsUrls.length > 0"
                              icon
                              x-small
                              @click="toggleTrackingItemExpanded(index)"
                              class="ml-1 text-none"
                            >
                              <v-icon x-small>
                                {{
                                  expandedTrackingItems[index]
                                    ? 'mdi-chevron-up'
                                    : 'mdi-chevron-down'
                                }}
                              </v-icon>
                            </v-btn>

                            <v-btn
                              icon
                              x-small
                              @click="confirmDelete(index)"
                              class="ml-1 text-none"
                              :disabled="isViewer"
                            >
                              <v-icon x-small>mdi-close</v-icon>
                            </v-btn>
                          </div>

                          <!-- Expandable matched URLs section -->
                          <v-expand-transition>
                            <div
                              v-if="
                                expandedTrackingItems[index] && trackingItem.matchsUrls.length > 0
                              "
                              class="mt-2 pt-2 border-t"
                            >
                              <div class="text-caption text--secondary mb-1 font-weight-medium">
                                Competitor URLs:
                              </div>
                              <div
                                v-for="(matchUrl, urlIndex) in trackingItem.matchsUrls"
                                :key="urlIndex"
                                class="d-flex align-center mb-1"
                              >
                                <img
                                  v-if="getFaviconUrl(matchUrl.matchUrl)"
                                  :src="getFaviconUrl(matchUrl.matchUrl)"
                                  width="14"
                                  height="14"
                                  class="favicon-icon mr-2"
                                  @error="onFaviconError"
                                />
                                <v-icon v-else x-small color="grey" class="mr-2"
                                  >mdi-link-variant</v-icon
                                >
                                <span class="text-caption text--secondary text-truncate">
                                  {{ extractDomain(matchUrl.matchUrl) }}
                                </span>
                              </div>
                            </div>
                          </v-expand-transition>
                        </v-card-text>
                      </v-card>
                    </div>
                  </div>
                </div>
                <v-divider></v-divider>
                <!-- Start Tracking Button -->
                <div class="d-flex justify-end mt-4">
                  <v-btn
                    medium
                    color="error"
                    @click="startProductTracking"
                    :disabled="trackingList.length === 0 || submitting || isViewer"
                    :loading="submitting"
                    :class="[
                      'text-none px-8',
                      { 'tracking-button-animation': trackingList.length > 0 && !submitting },
                    ]"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    Start Tracking {{ trackingList.length }} Product{{
                      trackingList.length !== 1 ? 's' : ''
                    }}
                  </v-btn>
                </div>
              </v-card-text>
              <v-card-text class="px-0">
                <!-- Single Product Input Form -->
                <div class="single-product-form">
                  <v-row justify="center">
                    <v-col cols="12">
                      <!-- Quick Tip -->
                      <div
                        v-if="showQuickTip"
                        class="mb-4 px-3 py-2 rounded-lg"
                        style="background-color: #fff8e1; border-radius: 2px; position: relative"
                      >
                        <div
                          class="text-caption text--secondary d-flex align-center"
                          style="padding-right: 24px"
                        >
                          <v-icon small class="mr-3">mdi-lightbulb-on-outline</v-icon>
                          <!-- <span class="mr-1">💡</span> -->
                          <strong class="mr-1">Quick tip:</strong>
                          Add 2-3 competitors per product for best price intelligence
                        </div>
                        <v-btn
                          icon
                          x-small
                          @click="closeQuickTip"
                          style="position: absolute; top: 4px; right: 4px"
                          class="mt-1 text-none"
                        >
                          <v-icon small color="grey">mdi-close</v-icon>
                        </v-btn>
                      </div>
                      <v-card outlined class="elevation-20 rounded-xl" v-if="!hideProductsInputs">
                        <v-card-text class="pa-4">
                          <!-- Main Product URL Input -->
                          <v-row>
                            <v-col cols="12" md="8">
                              <div class="d-flex align-center justify-between mb-2">
                                <div class="d-flex align-center">
                                  <!-- <v-icon small color="primary" class="mr-2">mdi-web</v-icon> -->
                                  <span class="text-subtitle-2 font-weight-bold"
                                    >Your product url
                                  </span>
                                </div>
                              </div>
                              <v-text-field
                                label="https://yourstore.com/product/..."
                                v-model="singleProduct.mainProductUrl"
                                :rules="[rules.url]"
                                :error-messages="getUrlErrorMessage(singleProduct.mainProductUrl)"
                                outlined
                                dense
                                hide-details
                                :disabled="isViewer"
                              >
                                <template v-slot:prepend-inner class="pa-0">
                                  <div class="dflex align-center justify-center">
                                    <img
                                      v-if="getFaviconUrl(singleProduct.mainProductUrl)"
                                      :src="getFaviconUrl(singleProduct.mainProductUrl)"
                                      width="16"
                                      height="16"
                                      class="favicon-icon"
                                      @error="onFaviconError"
                                    />
                                    <v-icon v-else small color="grey" class="favicon-icon"
                                      >mdi-link</v-icon
                                    >
                                  </div>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                              <div class="d-flex align-center justify-between mb-2">
                                <div class="d-flex align-center">
                                  <!-- <v-icon small color="primary" class="mr-2">mdi-web</v-icon> -->
                                  <span class="text-subtitle-2 font-weight-bold"
                                    >SKU/EAN (optional)</span
                                  >
                                </div>
                              </div>
                              <v-text-field
                                label="Ex: SKU12345 or 01234567890123"
                                v-model="singleProduct.eanSku"
                                outlined
                                dense
                                hide-details
                                :disabled="isViewer"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon small color="grey" class="favicon-icon"
                                    >mdi-barcode</v-icon
                                  >
                                </template>
                              </v-text-field>

                              <div class="d-flex align-center justify-between mb-2 mt-3">
                                <div class="d-flex align-center">
                                  <!-- <v-icon small color="primary" class="mr-2">mdi-web</v-icon> -->
                                  <span class="text-subtitle-2 font-weight-bold"
                                    >Price (optional)</span
                                  >
                                </div>
                              </div>
                              <v-text-field
                                label="Ex: 100"
                                v-model="singleProduct.price"
                                outlined
                                dense
                                type="number"
                                hide-details
                                :disabled="isViewer"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon small color="grey" class="favicon-icon"
                                    >mdi-currency-usd</v-icon
                                  >
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>

                          <!-- Extra Fields Section -->
                          <v-row
                            v-for="(field, fieldIndex) in selectedExtraFields"
                            v-bind:key="field"
                            class="mt-2"
                          >
                            <v-col cols="6">
                              <v-text-field
                                :label="`${field} (optional)`"
                                v-model="singleProduct[field]"
                                :type="field == 'cost' ? 'number' : 'text'"
                                :min="field == 'cost' ? 0 : null"
                                dense
                                hide-details
                                outlined
                                :disabled="isViewer"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="1 pt-5"
                              @click="!isViewer && selectedExtraFields.splice(fieldIndex, 1)"
                              style="cursor: pointer"
                            >
                              <v-icon medium v-if="!isViewer">mdi-close-circle-outline</v-icon>
                            </v-col>
                          </v-row>

                          <div
                            class="mt-2"
                            v-if="selectedExtraFields.length < extraFields.length"
                            hidden
                          >
                            <v-menu open-on-click offset-y bottom :close-on-content-click="false">
                              <template v-slot:activator="{ on: menu }">
                                <v-btn
                                  small
                                  outlined
                                  color="primary"
                                  class="text-none"
                                  v-on="{ ...menu }"
                                  :disabled="isViewer"
                                >
                                  Add More Attributes <v-icon right dark>$add</v-icon>
                                </v-btn>
                              </template>
                              <v-card class="pa-0" flat>
                                <v-card-text>
                                  <v-row
                                    v-for="field in extraFields.filter(
                                      (field) => !selectedExtraFields.includes(field),
                                    )"
                                    v-bind:key="field"
                                    @click="selectedExtraFields.push(field)"
                                    style="cursor: pointer"
                                    class="ma-0"
                                  >
                                    <v-col cols="1">
                                      <v-icon small>mdi-plus-circle-outline</v-icon>
                                    </v-col>
                                    <v-col cols="10"> {{ field }}</v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                            </v-menu>
                          </div>
                          <!-- Add button when no matched URLs exist -->
                          <div
                            v-if="singleProduct.matchsUrls.length === 0"
                            class="d-flex align-center justify-end mt-4"
                          >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon small color="info" class="mr-2" v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>
                                Add competitor URLs to track prices across multiple stores.<br />
                                This helps you monitor price changes and stay competitive.
                              </span>
                            </v-tooltip>

                            <v-btn
                              small
                              outlined
                              color="primary"
                              @click="addCompetitorUrl"
                              :disabled="!canAddCompetitorUrl || isViewer"
                              :class="['text-none', { 'animated-button': canAddCompetitorUrl }]"
                            >
                              <v-icon small left>mdi-plus</v-icon>
                              Add new competitor
                            </v-btn>
                          </div>

                          <!-- Competitor URLs Section -->
                          <div v-if="singleProduct.matchsUrls.length > 0" class="mt-6">
                            <!-- Section Header -->
                            <div class="d-flex align-center justify-between mb-2">
                              <div class="d-flex align-center">
                                <v-icon small color="primary" class="mr-2">mdi-link-variant</v-icon>
                                <span class="text-subtitle-2 font-weight-bold"
                                  >Competitor URLs ({{ singleProduct.matchsUrls.length }})</span
                                >
                              </div>
                            </div>

                            <!-- Matched URLs List -->
                            <div class="ml-6">
                              <div
                                v-for="(matchUrl, index) in singleProduct.matchsUrls"
                                :key="index"
                                class="mb-3"
                              >
                                <v-row no-gutters class="align-center">
                                  <v-text-field
                                    :ref="`competitorInput${index}`"
                                    :label="`Enter competitor URL ${index + 1}`"
                                    v-model="matchUrl.matchUrl"
                                    :rules="[rules.url]"
                                    :error-messages="
                                      getCompetitorUrlError(matchUrl.matchUrl, index)
                                    "
                                    dense
                                    outlined
                                    hide-details="auto"
                                    @keydown.enter="handleEnterOnMatchUrl(index, $event)"
                                    :disabled="isViewer"
                                  >
                                    <template v-slot:prepend>
                                      <v-icon small color="grey"
                                        >mdi-subdirectory-arrow-right</v-icon
                                      >
                                    </template>
                                    <template v-slot:prepend-inner>
                                      <img
                                        v-if="getFaviconUrl(matchUrl.matchUrl)"
                                        :src="getFaviconUrl(matchUrl.matchUrl)"
                                        width="16"
                                        height="16"
                                        class="favicon-icon"
                                        @error="onFaviconError"
                                      />
                                      <v-icon v-else small color="grey" class="favicon-icon"
                                        >mdi-link-variant</v-icon
                                      >
                                    </template>
                                    <template v-slot:append>
                                      <v-icon
                                        v-if="singleProduct.matchsUrls.length > 1 && !isViewer"
                                        medium
                                        @click="removeCompetitorUrl(index)"
                                        color="grey"
                                      >
                                        mdi-close
                                      </v-icon>
                                    </template>
                                  </v-text-field>
                                </v-row>
                              </div>
                              <!-- Add new competitor URL button when matched URLs exist -->
                              <div
                                v-if="singleProduct.matchsUrls.length > 0"
                                class="d-flex align-center justify-end mt-4"
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      small
                                      color="success"
                                      class="mr-2"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>
                                    Add more competitor URLs to get better price insights.<br />
                                    More competitors = better market coverage!
                                  </span>
                                </v-tooltip>

                                <v-btn
                                  small
                                  color="success"
                                  @click="addCompetitorUrl"
                                  :disabled="!canAddCompetitorUrl || isViewer"
                                  :class="[
                                    'text-none',
                                    // { 'animated-button': canAddCompetitorUrl }
                                  ]"
                                >
                                  <v-icon small left>mdi-plus</v-icon>
                                  Add new competitor URL
                                </v-btn>
                              </div>
                            </div>
                          </div>
                          <!-- Submit Button -->
                          <div class="mt-6 text-center">
                            <v-btn
                              medium
                              color="primary"
                              @click="addToTrackingList"
                              :disabled="!isProductValid || isViewer"
                              class="text-none w-100"
                            >
                              <v-icon small left>mdi-plus</v-icon>
                              Add product match
                            </v-btn>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <!-- File Import Tab -->
      <div v-if="activeTab === 1">
        <v-row class="justify-center">
          <v-col align-self="center" cols="12" md="8">
            <v-card class="px-10 pb-10" elevation="0">
              <v-card-title>
                Import Products from File
                <v-spacer></v-spacer>
                <!-- <v-chip small color="info" outlined>
                  <v-icon small left>mdi-information-outline</v-icon>
                  Bulk Import
                </v-chip> -->
              </v-card-title>
              <!-- Quick Tip -->
              <div
                v-if="showQuickTip"
                class="mb-1 px-3 py-2 rounded-lg"
                style="background-color: #fff8e1; border-radius: 2px; position: relative"
              >
                <div
                  class="text-caption text--secondary d-flex align-center"
                  style="padding-right: 24px"
                >
                  <v-icon small class="mr-3">mdi-lightbulb-on-outline</v-icon>
                  <!-- <span class="mr-1">💡</span> -->
                  <strong class="mr-1">Quick tip:</strong>
                  Add 2-3 competitors per product for best price intelligence
                </div>
                <v-btn
                  icon
                  x-small
                  @click="closeQuickTip"
                  style="position: absolute; top: 4px; right: 4px"
                  class="mt-1 text-none"
                >
                  <v-icon small color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text class="px-0">
                <!-- File Upload Section -->
                <div class="file-upload-section mb-6">
                  <v-card class="elevation-20 rounded-xl">
                    <v-card-text class="pa-0">
                      <!-- Upload Area / Selected File Display -->
                      <div
                        class="upload-dropzone text-center py-8 px-4"
                        :class="{
                          dragover: isDragOver,
                          processing: fileProcessing,
                          'file-selected': selectedFile && !fileProcessing,
                        }"
                        @dragover.prevent="!selectedFile && !isViewer && (isDragOver = true)"
                        @dragleave.prevent="isDragOver = false"
                        @drop.prevent="!selectedFile && !isViewer && handleFileDrop($event)"
                        @click="!fileProcessing && !selectedFile && !isViewer && triggerFileInput()"
                      >
                        <!-- Processing State -->
                        <template v-if="fileProcessing">
                          <v-progress-circular
                            size="64"
                            color="primary"
                            indeterminate
                            class="mb-4"
                          ></v-progress-circular>
                          <div class="text-h6 mb-2">Processing file...</div>
                          <div class="text-body-2 grey--text mb-4">
                            Please wait while we validate your data
                          </div>
                        </template>

                        <!-- File Selected State -->
                        <template v-else-if="selectedFile">
                          <v-icon size="64" color="success" class="mb-4">mdi-file-check</v-icon>
                          <div class="text-h6 mb-2">{{ selectedFile.name }}</div>
                          <div class="text-body-2 grey--text mb-4">
                            {{ formatFileSize(selectedFile.size) }} •
                            {{ selectedFile.type || 'CSV File' }} •
                            <span v-if="validationResults"
                              >{{ validationResults.valid + validationResults.warnings }} products
                              detected</span
                            >
                            <span v-else-if="convertedProducts.length > 0"
                              >{{ convertedProducts.length }} products detected</span
                            >
                          </div>

                          <div class="d-flex justify-center align-center gap-2">
                            <v-btn
                              class="text-none"
                              color="primary"
                              outlined
                              small
                              @click.stop="triggerFileInput"
                              :disabled="isViewer"
                            >
                              <v-icon small left>mdi-file-replace</v-icon>
                              Replace File
                            </v-btn>
                            <v-btn
                              class="text-none"
                              color="error"
                              outlined
                              small
                              @click.stop="removeSelectedFile"
                              :disabled="isViewer"
                            >
                              <v-icon small left>mdi-close</v-icon>
                              Remove File
                            </v-btn>
                          </div>

                          <div class="text-caption grey--text mt-3">
                            File processed successfully. Review the data below and click "Import to
                            Tracking List" when ready.
                          </div>
                        </template>

                        <!-- Upload State -->
                        <template v-else>
                          <v-icon size="64" color="primary" class="mb-4">mdi-cloud-upload</v-icon>
                          <div class="text-h6 mb-2">Drag and drop your file here</div>
                          <div class="text-body-2 grey--text mb-4">or click to browse files</div>

                          <v-btn
                            class="text-none mb-4"
                            color="primary"
                            outlined
                            @click.stop="triggerFileInput"
                            :disabled="isViewer"
                          >
                            <v-icon left>mdi-file-upload</v-icon>
                            Choose File
                          </v-btn>

                          <div class="text-caption grey--text">
                            Supported formats: CSV, Excel (.xlsx, .xls)
                          </div>
                        </template>

                        <!-- Hidden file input -->
                        <input
                          ref="fileInput"
                          type="file"
                          accept=".csv,.xlsx,.xls"
                          style="display: none"
                          @change="handleFileSelect"
                        />
                      </div>
                    </v-card-text>
                  </v-card>
                </div>

                <!-- File Format Requirements -->
                <div class="mb-6" v-if="!selectedFile">
                  <v-expansion-panels :value="0" flat>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div class="d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-format-list-bulleted</v-icon>
                          <span class="font-weight-medium">File Format Requirements</span>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div class="pa-2">
                          <!-- Sample Format Table -->
                          <div class="mb-4">
                            <div class="d-flex align-center mb-3">
                              <v-icon small color="primary" class="mr-2">mdi-table</v-icon>
                              <span class="text-subtitle-2 font-weight-medium"
                                >Expected CSV Format:</span
                              >
                            </div>

                            <div class="table-container-with-overlay">
                              <v-card outlined class="sample-format-table">
                                <v-simple-table dense>
                                  <template v-slot:default>
                                    <thead>
                                      <tr class="sample-header">
                                        <th class="text-left font-weight-bold required-column">
                                          SKU
                                          <div class="column-requirement">Required</div>
                                        </th>
                                        <th class="text-left font-weight-bold optional-column">
                                          EAN
                                          <div class="column-requirement">Optional</div>
                                        </th>
                                        <th class="text-left font-weight-bold optional-column">
                                          NAME
                                          <div class="column-requirement">Optional</div>
                                        </th>
                                        <th class="text-left font-weight-bold optional-column">
                                          BRAND
                                          <div class="column-requirement">Optional</div>
                                        </th>
                                        <th class="text-left font-weight-bold optional-column">
                                          PRICE
                                          <div class="column-requirement">Optional</div>
                                        </th>
                                        <th class="text-left font-weight-bold optional-column">
                                          IMAGE
                                          <div class="column-requirement">Optional</div>
                                        </th>
                                        <th class="text-left font-weight-bold required-column">
                                          MY_URL
                                          <div class="column-requirement">Required</div>
                                        </th>
                                        <th class="text-left font-weight-bold optional-column">
                                          COMPETITOR_1
                                          <div class="column-requirement">Optional</div>
                                        </th>
                                        <th class="text-left font-weight-bold optional-column">
                                          COMPETITOR_2
                                          <div class="column-requirement">Optional</div>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td class="sample-data">ABC123</td>
                                        <td class="sample-data">1234567890123</td>
                                        <td class="sample-data">Wireless Headphones</td>
                                        <td class="sample-data">TechBrand</td>
                                        <td class="sample-data">199.99</td>
                                        <td class="sample-data">https://mystore.com/img1.jpg</td>
                                        <td class="sample-data">https://mystore.com/headphones</td>
                                        <td class="sample-data">https://amazon.com/product1</td>
                                        <td class="sample-data">https://bestbuy.com/product1</td>
                                      </tr>
                                      <tr>
                                        <td class="sample-data">DEF456</td>
                                        <td class="sample-data">9876543210987</td>
                                        <td class="sample-data">Gaming Mouse</td>
                                        <td class="sample-data">GameCorp</td>
                                        <td class="sample-data">12.50</td>
                                        <td class="sample-data"></td>
                                        <td class="sample-data">
                                          https://mystore.com/gaming-mouse
                                        </td>
                                        <td class="sample-data">https://ebay.com/product2</td>
                                        <td class="sample-data">https://walmart.com/product2</td>
                                      </tr>
                                      <tr>
                                        <td class="sample-data">GHI789</td>
                                        <td class="sample-data"></td>
                                        <td class="sample-data">Smartphone Case</td>
                                        <td class="sample-data">CaseMaker</td>
                                        <td class="sample-data">25.00</td>
                                        <td class="sample-data">https://mystore.com/img3.jpg</td>
                                        <td class="sample-data">https://mystore.com/phone-case</td>
                                        <td class="sample-data">https://target.com/product3</td>
                                        <td class="sample-data"></td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-card>

                              <!-- Hover Overlay with Download Button -->
                              <!-- <v-overlay absolute class="table-hover-overlay">
                              <v-btn
                                large
                                color="primary"
                                elevation="8"
                                @click="downloadCSVTemplate"
                              >
                                <v-icon left>mdi-download</v-icon>
                                Download CSV Template
                              </v-btn>
                            </v-overlay> -->
                            </div>
                            <!-- Bottom Left Download Button -->
                            <v-btn
                              small
                              color="primary"
                              class="mt-2 text-none"
                              outlined
                              @click="downloadCSVTemplate"
                              :disabled="isViewer"
                            >
                              <v-icon x-small left>mdi-download</v-icon>
                              Download CSV Template
                            </v-btn>
                            <div class="text-caption grey--text mt-2 text-center">
                              <v-icon x-small class="mr-1">mdi-information-outline</v-icon>
                              Empty cells are allowed for optional fields. Each row represents one
                              product to track.
                            </div>
                          </div>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>

                <!-- Preview Section -->
                <div class="file-preview mb-6" v-if="selectedFile && previewData.length > 0">
                  <v-card class="elevation-0">
                    <v-card-subtitle class="pb-2">
                      <div class="d-flex align-center justify-between">
                        <!-- <div class="mr-2">
                          <v-icon small color="primary" class="mr-2">mdi-table-eye</v-icon>
                          File Preview
                        </div> -->
                        <v-btn
                          small
                          :color="showPreviewTable ? 'error' : 'success'"
                          :outlined="!showPreviewTable"
                          @click="showPreviewTable = !showPreviewTable"
                          class="text-none"
                        >
                          <v-icon small left>
                            {{ showPreviewTable ? 'mdi-eye-off' : 'mdi-table-eye' }}
                          </v-icon>
                          <!-- {{ showPreviewTable ? 'Hide' : 'Show' }} {{ previewData.length }} rows -->
                          {{ 'File preview ' }} ({{ previewData.length }} rows)
                        </v-btn>
                      </div>
                    </v-card-subtitle>
                    <v-card-text class="pt-0" v-if="showPreviewTable">
                      <v-data-table
                        :headers="previewHeaders"
                        :items="previewData"
                        :items-per-page="previewItemsPerPage"
                        :footer-props="{
                          itemsPerPageOptions: previewPageOptions,
                          itemsPerPageText: 'Rows per page:',
                          showFirstLastPage: true,
                          showCurrentPage: true,
                        }"
                        class="elevation-0"
                        dense
                      >
                        <!-- Row Status Indicator -->
                        <template v-slot:item.status="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                small
                                v-bind="attrs"
                                v-on="on"
                                :color="
                                  item.status === 'error'
                                    ? 'error'
                                    : item.status === 'warning'
                                      ? 'warning'
                                      : 'success'
                                "
                              >
                                {{
                                  item.status === 'error'
                                    ? 'mdi-alert-circle'
                                    : item.status === 'warning'
                                      ? 'mdi-alert'
                                      : 'mdi-check-circle'
                                }}
                              </v-icon>
                            </template>
                            <span>
                              {{
                                item.status === 'error'
                                  ? 'Row has errors'
                                  : item.status === 'warning'
                                    ? 'Row has warnings'
                                    : 'Row is valid'
                              }}
                              <br />{{ item.statusMessage || '' }}
                            </span>
                          </v-tooltip>
                        </template>

                        <!-- SKU Column -->
                        <template v-slot:item.sku="{ item }">
                          <span
                            :class="{
                              'error--text': item.status === 'error',
                              'warning--text': item.status === 'warning',
                            }"
                          >
                            {{ item.sku }}
                          </span>
                        </template>

                        <!-- My URL Column -->
                        <template v-slot:item.my_url="{ item }">
                          <div class="d-flex align-center">
                            <img
                              v-if="getFaviconUrl(item.my_url)"
                              :src="getFaviconUrl(item.my_url)"
                              width="16"
                              height="16"
                              class="favicon-icon mr-2"
                              @error="onFaviconError"
                            />
                            <v-icon v-else small color="grey" class="mr-2">mdi-link</v-icon>
                            <span
                              class="text-truncate"
                              style="max-width: 200px"
                              :class="{
                                'error--text': item.status === 'error',
                                'warning--text': item.status === 'warning',
                              }"
                            >
                              {{ item.my_url }}
                            </span>
                          </div>
                        </template>

                        <!-- Price Column -->
                        <template v-slot:item.price="{ item }">
                          <span
                            :class="{
                              'error--text': item.status === 'error',
                              'warning--text': item.status === 'warning',
                            }"
                          >
                            {{ item.price || '-' }}
                          </span>
                        </template>

                        <!-- EAN Column -->
                        <template v-slot:item.ean="{ item }">
                          <span
                            :class="{
                              'error--text': item.status === 'error',
                              'warning--text': item.status === 'warning',
                            }"
                          >
                            {{ item.ean || '-' }}
                          </span>
                        </template>

                        <!-- Name Column -->
                        <template v-slot:item.name="{ item }">
                          <span
                            :class="{
                              'error--text': item.status === 'error',
                              'warning--text': item.status === 'warning',
                            }"
                          >
                            {{ item.name || '-' }}
                          </span>
                        </template>

                        <!-- Brand Column -->
                        <template v-slot:item.brand="{ item }">
                          <span
                            :class="{
                              'error--text': item.status === 'error',
                              'warning--text': item.status === 'warning',
                            }"
                          >
                            {{ item.brand || '-' }}
                          </span>
                        </template>

                        <!-- Competitors Column -->
                        <template v-slot:item.competitors="{ item }">
                          <span
                            :class="{
                              'error-text': item.status === 'error',
                              'warning-text': item.status === 'warning',
                              'success-text': item.status === 'success',
                            }"
                          >
                            {{ item.competitors }}
                          </span>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </div>

                <!-- Validation Results -->
                <div class="validation-results mb-6" v-if="selectedFile && validationResults">
                  <v-card elevation="0">
                    <v-card-text class="pa-0">
                      <!-- Header -->
                      <div class="d-flex align-center mb-4">
                        <v-icon color="primary" class="mr-3">mdi-clipboard-check-outline</v-icon>
                        <h3 class="text-h6 mb-0">Validation Summary</h3>
                        <v-spacer></v-spacer>
                        <!-- <v-chip small :color="validationResults.errors > 0 ? 'error' : validationResults.warnings > 0 ? 'warning' : 'success'" outlined>
                          {{ validationResults.errors > 0 ? 'Has Errors' : validationResults.warnings > 0 ? 'Ready with Warnings' : 'All Valid' }}
                        </v-chip> -->
                      </div>

                      <!-- Stats Cards -->
                      <v-row class="validation-stats">
                        <v-col cols="12" sm="4" class="pa-2">
                          <v-card outlined class="validation-stat-card success-card" elevation="0">
                            <v-card-text class="d-flex align-center pa-3">
                              <div class="stat-icon mr-3">
                                <v-icon size="24" color="success">mdi-check-circle</v-icon>
                              </div>
                              <div class="stat-content">
                                <div class="stat-number">
                                  {{ validationResults.valid + validationResults.warnings }}
                                </div>
                                <div class="stat-label">Valid Rows</div>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" sm="4" class="pa-2" v-if="validationResults.warnings > 0">
                          <v-card outlined class="validation-stat-card warning-card" elevation="0">
                            <v-card-text class="d-flex align-center pa-3">
                              <div class="stat-icon mr-3">
                                <v-icon size="24" color="info">mdi-information-outline</v-icon>
                              </div>
                              <div class="stat-content">
                                <div class="stat-number">{{ validationResults.warnings }}</div>
                                <div class="stat-label">Missing Optional Fields</div>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" sm="4" class="pa-2" v-if="validationResults.errors > 0">
                          <v-card outlined class="validation-stat-card error-card">
                            <v-card-text class="d-flex align-center pa-3">
                              <div class="stat-icon mr-3">
                                <v-icon size="24" color="error">mdi-close-circle</v-icon>
                              </div>
                              <div class="stat-content">
                                <div class="stat-number">{{ validationResults.errors }}</div>
                                <div class="stat-label">Errors</div>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>

                      <!-- Info Message -->
                      <!-- <v-alert 
                        type="info" 
                        text
                        class="mt-4 mb-0 info-message" 
                        v-if="validationResults && validationResults.warnings > 0 && validationResults.errors === 0"
                      >
                        <div class="d-flex align-start">
                          <div>
                            <strong>Good to go!</strong> Products with warnings can still be imported. 
                            <br><span class="text-caption">Warnings indicate missing optional fields that won't affect price tracking functionality.</span>
                          </div>
                        </div>
                      </v-alert> -->
                    </v-card-text>
                  </v-card>
                </div>

                <!-- Action Buttons -->
                <div class="action-buttons text-center">
                  <v-btn
                    large
                    color="primary"
                    :disabled="!selectedFile || !canImport || fileProcessing || isViewer"
                    :loading="fileProcessing"
                    class="text-none px-8 mr-4 w-100"
                    @click="importToTrackingList"
                  >
                    <v-icon left>mdi-arrow-right-bold-circle</v-icon>
                    <!-- Add {{ selectedFile ? (validationResults?.valid || 0) + (validationResults?.warnings || 0) : 0 }} to Tracking List -->
                    Next
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>

    <!-- Multiple Products Modal -->
    <ImportSingleProduct
      :dialog="show_multiple_products_modal"
      @close-dialog="show_multiple_products_modal = false"
      @show-notification="showNotification"
      @import-success="onImportSuccess"
    />
    <v-row class="px-16" v-if="showRecentImportations">
      <v-divider></v-divider>
    </v-row>
    <v-row class="justify-center" v-if="showRecentImportations">
      <v-col align-self="center" cols="12" md="8">
        <v-card text elevation="0" class="px-0">
          <v-card-title class="mb-10 px-0">
            <span class="md-text">Recent Importations</span>
            <div class="ml-auto d-flex flex-column mr-4 px-0">
              <span :class="inserted == limit ? 'error-color' : ''" class="ma-0 text-right sm-text">
                Matches : {{ inserted }} / {{ limit }}
              </span>

              <v-progress-linear
                height="15"
                style="width: 250px"
                :value="limit_percentage"
                :color="limit_progress_color"
                bottom
                rounded
                reactive
              >
              </v-progress-linear>
            </div>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="isDevMode"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :disabled="isViewer"
                  light
                  color="primary"
                  @click="showProductsCreationModal"
                  class="ml-2 text-none"
                  >Automatic Creation
                  <v-icon right dark>mdi-robot</v-icon>
                </v-btn>
                <!-- <v-btn
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  light
                  color="primary"
                  small
                  class="mt-4"
                  @click="showImportModal"
                  >Upload new products file
                  <v-icon right dark>mdi-database-import</v-icon>
                </v-btn> -->
              </template>
              <span>import matches</span>
            </v-tooltip>
          </v-card-title>
          <v-card-text class="px-0">
            <v-row>
              <importationTable
                class="w-100"
                :importations="importations"
                @show-handle-error-modal="showHandleErrorModal"
                @get-requests-event="getRequestsPager"
                @confirm-modal-event="confirmModal"
                @update-statistics="updateStatistics"
              />
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" hidden>
        <v-row justify="center">
          <v-col lg="auto">
            <v-card
              @click="showTutorial"
              class="d-inline-block pa-4 mr-3 ml-3 card-botton"
              max-width="500"
              ripple
            >
              <v-card-text>
                <div class="d-flex justify-center">
                  <v-icon size="100"> mdi-information-outline </v-icon>
                </div>
                <div class="mt-2">
                  <div class="font-weight-bold text-center xl-text">How to prepare your import</div>
                  <div class="text-center mt-4 md-text">
                    the guide will show you how to prepare you import file and how to import using a
                    form
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col lg="auto">
            <v-card
              class="d-inline-block pa-4 mr-3 ml-3 card-botton"
              max-width="500"
              ripple
              @click="!isViewer && downloadSampleFile()"
            >
              <v-card-text>
                <div class="d-flex justify-center">
                  <v-icon size="100"> mdi-download </v-icon>
                </div>
                <div class="mt-2">
                  <div class="font-weight-bold text-center xl-text">
                    Download sample import file
                  </div>
                  <div class="text-center mt-4 md-text">
                    would you like to see how import file looks like ? Download sample file and test
                    import process
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog v-model="show_confirm_dialog" eager max-width="30%">
      <v-card>
        <v-card-title>
          <span class="md-text">Importation Confirmation</span>
          <v-btn class="text-none ml-auto" icon @click="show_confirm_dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-alert type="warning" class="mb-0 mt-4 font-weight-bold delete-text">
            {{ modal_error_msg }}
            <br />
            Confirm to insert till the limit, or rollback the importation
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="text-none" color="primary" text @click="show_confirm_dialog = false"
            >cancel</v-btn
          >
          <v-btn class="text-none white--text" color="delete" @click="confirmInsertion(false)"
            >Rollback !</v-btn
          >
          <v-btn class="text-none" color="secondary" @click="confirmInsertion(true)"
            >Yes, import it !</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <errorHandlerTable
      :show="show_error_handler_modal"
      :data="errors_info"
      :loading="errors_loading"
      :isSingleProduct="isSingleProduct"
      :error_id="error_id"
      @show-notification="showNotification"
    />
    <productsCreationModal
      :show="show_products_creation_modal"
      :inserted="inserted"
      :limit="limit"
      @show-notification="showNotification"
    />

    <importModal
      :show="show_import_modal"
      :inserted="inserted"
      :limit="limit"
      @show-notification="showNotification"
    />

    <!-- Delete Confirmation Modal -->
    <v-dialog v-model="show_delete_confirmation" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="md-text">Delete confirmation</span>
        </v-card-title>
        <v-card-text>
          <v-alert type="warning" class="mb-0 mt-4 mb-4 grow" prominent>
            Are you sure you want to permanently remove this product from your tracking list?
          </v-alert>
          <p class="text-caption text--secondary mb-0">
            This action cannot be undone. The product and all its competitor URLs will be removed.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            class="text-none"
            small
            @click="confirmRemoveFromTrackingList"
          >
            Yes, delete it!
          </v-btn>
          <v-btn color="error" small class="text-none" @click="show_delete_confirmation = false">
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <snackbar :show="snackbar" :color="snackbar_color" :msg="snackbar_msg" />
  </div>
</template>
<script>
  import importModal from './importModal.vue'
  import errorHandlerTable from './errorHandlerTable.vue'
  import importationTable from './importationTable.vue'
  import productsCreationModal from './productsCreationModal.vue'
  import ImportSingleProduct from '../common/ImportSingleProduct.vue'
  import axios from 'axios'

  export default {
    name: 'Importations',
    data() {
      return {
        hideProductsInputs: false,
        isDevMode: false,
        snackbar_color: '',
        snackbar_msg: '',
        snackbar: false,
        show_error_handler_modal: false,
        modal_error_msg: '',
        error_id: '',
        importations: [],
        errors_info: [],
        selected_item: {},
        errors_loading: false,
        inserted: 0,
        limit: 0,
        isSingleProduct: false,
        show_import_modal: false,
        show_products_creation_modal: false,
        show_confirm_dialog: false,
        show_multiple_products_modal: false,
        show_delete_confirmation: false,
        deleteItemIndex: null,
        submitting: false,
        activeTab: 0, // 0 for single product, 1 for file import
        trackingList: [], // List to store products before adding to price tracking
        showQuickTip: true, // Controls visibility of the quick tip

        // File import related data
        selectedFile: null,
        isDragOver: false,
        importing: false,
        previewData: [],
        previewHeaders: [
          { text: '', value: 'status', width: '5%', sortable: false },
          { text: 'SKU', value: 'sku', width: '15%' },
          { text: 'My URL', value: 'my_url', width: '25%' },
          { text: 'Price', value: 'price', width: '10%' },
          { text: 'EAN', value: 'ean', width: '10%' },
          { text: 'Name', value: 'name', width: '20%' },
          { text: 'Brand', value: 'brand', width: '15%' },
          { text: 'Competitors', value: 'competitors', width: '10%' },
        ],
        validationResults: null,
        // Pagination settings for file preview
        previewItemsPerPage: 10,
        previewPageOptions: [5, 10, 15, 25, 50, 100],
        showPreviewTable: false, // Controls visibility of file preview table
        convertedProducts: [], // Products converted from file to single product format
        fileProcessing: false,
        expandedTrackingItems: {}, // Track which tracking items are expanded to show matched URLs
        singleProduct: {
          mainProductUrl: '',
          eanSku: '',
          price: '',
          matchsUrls: [
            {
              matchUrl: '',
              label: 'Enter product URL',
              type: 'text',
              required: false,
            },
          ],
        },
        selectedExtraFields: [],
        extraFields: ['brand', 'category', 'cost'],
        rules: {
          required: (value) => !!value || 'This field is required.',
          url: (value) => {
            if (!value) return true // Allow empty for optional fields
            // Improved and more performant URL regex (no catastrophic backtracking)
            const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/i
            return urlPattern.test(value) || 'Please enter a valid URL (e.g., https://example.com)'
          },
        },
      }
    },
    mounted() {
      this.isDevMode = process.env.VUE_APP_MODE === 'dev'
      this.loadXLSXLibrary()

      // Check if user has previously closed the quick tip
      const tipClosed = localStorage.getItem('quickTipClosed')
      if (tipClosed === 'true') {
        this.showQuickTip = false
      }

      // Initial load of importations and statistics
      this.getRequests(0, 10)
      this.updateStatistics()
    },
    computed: {
      isViewer() {
        return this.$store.getters.userRole === 'viewer'
      },
      limit_percentage: function () {
        return (this.inserted / this.limit) * 100
      },
      limit_progress_color: function () {
        return this.limit_percentage > 70 && this.limit_percentage < 90
          ? 'yellow darken-2'
          : this.limit_percentage > 90 && this.limit_percentage < 100
            ? 'orange darken-2'
            : this.limit_percentage == 100
              ? 'red darken-2'
              : 'success'
      },
      canAddCompetitorUrl() {
        if (
          !this.singleProduct.mainProductUrl ||
          !this.isValidUrl(this.singleProduct.mainProductUrl)
        ) {
          return false
        }
        return this.singleProduct.matchsUrls.every((matchUrl, index) => {
          const url = matchUrl.matchUrl && matchUrl.matchUrl.trim()
          return url && this.isValidUrl(url) && !this.isDuplicateDomain(url, index)
        })
      },
      isProductValid() {
        if (
          !this.singleProduct.mainProductUrl ||
          !this.isValidUrl(this.singleProduct.mainProductUrl)
        ) {
          return false
        }
        return this.singleProduct.matchsUrls.every((matchUrl, index) => {
          if (!matchUrl.matchUrl) return true
          return (
            this.isValidUrl(matchUrl.matchUrl) && !this.isDuplicateDomain(matchUrl.matchUrl, index)
          )
        })
      },

      // File import computed properties
      canImport() {
        return (
          this.selectedFile &&
          this.validationResults &&
          (this.validationResults.valid > 0 || this.validationResults.warnings > 0) &&
          this.validationResults.errors === 0
        )
      },

      // Statistics computed properties
      totalProducts() {
        return this.trackingList.length
      },
      totalCompetitors() {
        // Collect all unique competitor domains across all products
        const competitorDomains = new Set()

        this.trackingList.forEach((product) => {
          if (!product.matchsUrls || product.matchsUrls.length === 0) return

          // Get main product domain to exclude it
          const mainDomain = product.mainProductUrl
            ? this.extractDomain(product.mainProductUrl)
            : ''

          // Add unique competitor domains (excluding main domain)
          product.matchsUrls.forEach((matchUrl) => {
            if (!matchUrl.matchUrl) return
            const competitorDomain = this.extractDomain(matchUrl.matchUrl)
            if (competitorDomain && competitorDomain !== mainDomain) {
              competitorDomains.add(competitorDomain)
            }
          })
        })

        return competitorDomains.size
      },
      totalMatches() {
        // Calculate total competitor URLs being tracked (excluding main product URLs)
        let totalCompetitorUrls = 0

        this.trackingList.forEach((product) => {
          if (product.matchsUrls) {
            // Count valid competitor URLs only
            totalCompetitorUrls += product.matchsUrls.filter(
              (matchUrl) => matchUrl.matchUrl && matchUrl.matchUrl.trim() !== '',
            ).length
          }
        })

        return totalCompetitorUrls
      },

      // Debug: Also calculate stats for file preview
      previewTotalProducts() {
        return this.convertedProducts.length
      },
      previewTotalCompetitors() {
        // Collect all unique competitor domains across all preview products
        const competitorDomains = new Set()

        this.convertedProducts.forEach((product) => {
          if (!product.matchsUrls || product.matchsUrls.length === 0) return

          // Get main product domain to exclude it
          const mainDomain = product.mainProductUrl
            ? this.extractDomain(product.mainProductUrl)
            : ''

          // Add unique competitor domains (excluding main domain)
          product.matchsUrls.forEach((matchUrl) => {
            if (!matchUrl.matchUrl) return
            const competitorDomain = this.extractDomain(matchUrl.matchUrl)
            if (competitorDomain && competitorDomain !== mainDomain) {
              competitorDomains.add(competitorDomain)
            }
          })
        })

        return competitorDomains.size
      },
      previewTotalMatches() {
        // Calculate total competitor URLs in preview (excluding main product URLs)
        let totalCompetitorUrls = 0

        this.convertedProducts.forEach((product) => {
          if (product.matchsUrls) {
            // Count valid competitor URLs only
            totalCompetitorUrls += product.matchsUrls.filter(
              (matchUrl) => matchUrl.matchUrl && matchUrl.matchUrl.trim() !== '',
            ).length
          }
        })

        return totalCompetitorUrls
      },

      // Check if there are any products to show statistics for
      hasAnyProducts() {
        return this.trackingList.length > 0 || this.convertedProducts.length > 0
      },
    },
    components: {
      ImportSingleProduct,
      importModal,
      importationTable,
      errorHandlerTable,
      productsCreationModal,
    },
    props: {
      showRecentImportations: {
        type: Boolean,
        default: true,
      },
      mainTitle: {
        type: String,
        default: 'Set Up Matches Easily',
      },
      subTitle: {
        type: String,
        default:
          'Configure product matches for accurate price monitoring and competitive insights.',
      },
    },
    methods: {
      // UI Methods
      closeQuickTip() {
        this.showQuickTip = false
        localStorage.setItem('quickTipClosed', 'true')
      },

      // Single Product Form Methods
      showAddMoreModal() {
        this.show_multiple_products_modal = true
      },

      addCompetitorUrl() {
        this.singleProduct.matchsUrls.push({
          matchUrl: '',
          label: 'Enter product URL',
          type: 'text',
          required: false,
        })
      },

      removeCompetitorUrl(index) {
        this.singleProduct.matchsUrls.splice(index, 1)
      },

      getFaviconUrl(url) {
        if (!url || !this.isValidUrl(url)) return null

        try {
          let domain = url
          if (!url.startsWith('http://') && !url.startsWith('https://')) {
            domain = 'https://' + url
          }

          const urlObj = new URL(domain)
          const hostname = urlObj.hostname

          return `https://www.google.com/s2/favicons?domain=${hostname}&sz=30`
        } catch (error) {
          return null
        }
      },

      onFaviconError(event) {
        event.target.style.display = 'none'
      },

      // Debounced URL validation to prevent UI freeze on paste
      isValidUrl: (() => {
        let timeout = null
        let lastUrl = ''
        let lastResult = false
        // Use the same improved regex as above
        const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/i
        return function (url) {
          if (url === lastUrl) return lastResult
          if (timeout) clearTimeout(timeout)
          let result = false
          timeout = setTimeout(() => {
            lastUrl = url
            lastResult = urlPattern.test(url)
          }, 10) // debounce 10ms
          result = urlPattern.test(url)
          lastUrl = url
          lastResult = result
          return result
        }
      })(),

      extractDomain(url) {
        try {
          let domain = url
          if (!url.startsWith('http://') && !url.startsWith('https://')) {
            domain = 'https://' + url
          }
          const urlObj = new URL(domain)
          return urlObj.hostname
        } catch (error) {
          return url
        }
      },

      isDuplicateDomain(url, excludeIndex = -1) {
        if (!url || !this.isValidUrl(url)) return false

        const currentDomain = this.extractDomain(url)

        // Only check against main product URL domain if main URL exists and is valid
        if (
          this.singleProduct.mainProductUrl &&
          this.isValidUrl(this.singleProduct.mainProductUrl)
        ) {
          const mainDomain = this.extractDomain(this.singleProduct.mainProductUrl)
          if (mainDomain === currentDomain) {
            return true
          }
        }

        // Check against other competitor URLs
        return this.singleProduct.matchsUrls.some((matchUrl, index) => {
          if (index === excludeIndex) return false // Exclude current field when editing
          if (!matchUrl.matchUrl || matchUrl.matchUrl.trim() === '') return false
          if (!this.isValidUrl(matchUrl.matchUrl)) return false

          const matchDomain = this.extractDomain(matchUrl.matchUrl)
          return matchDomain === currentDomain
        })
      },

      getUrlErrorMessage(url) {
        if (!url) return ''
        if (!this.isValidUrl(url)) {
          return 'Please enter a valid URL'
        }
        return ''
      },

      getCompetitorUrlError(url, index) {
        if (!url) return ''

        if (!this.isValidUrl(url)) {
          return 'Please enter a valid URL'
        }

        if (this.isDuplicateDomain(url, index)) {
          return 'This website is already added. Please use a different website.'
        }

        return ''
      },

      addToTrackingList() {
        if (!this.isProductValid) return

        // Filter matched URLs to include only validated ones
        const validMatchedUrls = this.singleProduct.matchsUrls.filter((matchUrl) => {
          return (
            matchUrl.matchUrl &&
            matchUrl.matchUrl.trim() !== '' &&
            this.isValidUrl(matchUrl.matchUrl.trim())
          )
        })

        // Create a copy of the product for the tracking list with filtered URLs
        const trackingItem = {
          mainProductUrl: this.singleProduct.mainProductUrl,
          eanSku: this.singleProduct.eanSku,
          user_ref: this.singleProduct.sku,
          name: this.singleProduct.name || '',
          matchsUrls: validMatchedUrls,
          price: this.singleProduct.price,
          brand: this.singleProduct.brand || '',
          addedAt: new Date(),
        }

        this.trackingList.push(trackingItem)

        // Show success message with count of valid URLs
        const totalValidUrls = validMatchedUrls.length
        const urlText = totalValidUrls === 1 ? 'competitor URL' : 'competitor URLs'

        //this.showNotification({
        //  msg: `Product added to tracking list successfully! (${totalValidUrls} ${urlText} included)`,
        //  type: 'success'
        //});

        // Reset form
        this.singleProduct = {
          mainProductUrl: '',
          eanSku: '',
          matchsUrls: [
            {
              matchUrl: '',
              label: 'Enter product URL',
              type: 'text',
              required: false,
            },
          ],
        }
      },

      removeFromTrackingList(trackingIndex) {
        this.trackingList.splice(trackingIndex, 1)
      },

      confirmDelete(index) {
        this.deleteItemIndex = index
        this.show_delete_confirmation = true
      },

      confirmRemoveFromTrackingList() {
        if (this.deleteItemIndex !== null) {
          this.trackingList.splice(this.deleteItemIndex, 1)
          this.deleteItemIndex = null
        }
        this.show_delete_confirmation = false
      },

      toggleTrackingItemExpanded(index) {
        this.$set(this.expandedTrackingItems, index, !this.expandedTrackingItems[index])
      },

      handleEnterOnMatchUrl(urlIndex, event) {
        // Prevent default form submission
        event.preventDefault()

        const currentMatchUrl = this.singleProduct.matchsUrls[urlIndex]
        const currentUrl = currentMatchUrl.matchUrl

        // Only proceed if the current URL is valid and not empty
        if (currentUrl && this.isValidUrl(currentUrl)) {
          // Check if this is the last matched URL in the list
          const isLastUrl = urlIndex === this.singleProduct.matchsUrls.length - 1

          if (isLastUrl && this.canAddCompetitorUrl) {
            // Add a new matched URL field
            this.addCompetitorUrl()

            // Focus on the newly created field after DOM update
            this.$nextTick(() => {
              const newInputIndex = this.singleProduct.matchsUrls.length - 1
              const newInputRef = this.$refs[`competitorInput${newInputIndex}`]
              if (newInputRef && newInputRef.length > 0) {
                // Vuetify text field focus method
                newInputRef[0].focus()
              }
            })
          }
        }
      },

      async startProductTracking() {
        if (this.trackingList.length === 0) return

        this.submitting = true

        try {
          // Prepare data for API
          const data = this.trackingList.map((product) => {
            // Get validated competitor URLs
            const validCompetitorUrls = product.matchsUrls
              .filter(
                (matchUrl) =>
                  matchUrl.matchUrl &&
                  matchUrl.matchUrl.trim() !== '' &&
                  this.isValidUrl(matchUrl.matchUrl.trim()),
              )
              .map((matchUrl) => matchUrl.matchUrl.trim())

            // Combine main URL and validated matched URLs
            const allUrls = [product.mainProductUrl, ...validCompetitorUrls]

            return {
              ref: product.eanSku || '',
              user_ref: product.user_ref || product.eanSku || '',
              ean: product.eanSku || '',
              model: '',
              brand: product.brand || '',
              category: '',
              price: product.price || 0.0,
              name: product.name || '',
              image: product.image || '',
              cost: 0.0,
              urls: allUrls.map((url) => ({ url: url.trim() })),
              id: 'TRACK_' + Date.now() + '_' + Math.random(),
            }
          })

          const params = {
            account_id: localStorage.getItem('account_id'),
            user_id: localStorage.getItem('user_id'),
            products: data,
            autoDiscovery: true,
          }

          await axios.post(
            '/api/importation/addproduts',
            {
              params: params,
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            },
          )

          this.showNotification({
            msg: 'The importation request has been successfully uploaded, it will be processed soon',
            type: 'success',
          })

          // Clear tracking list
          this.trackingList = []

          // Update statistics and importations list
          this.updateStatistics()
          this.getRequests(0, 10)

          setTimeout(() => {
            this.$emit('onImportSuccess')
          }, 1000)
        } catch (error) {
          console.error('Tracking setup error:', error)
          this.showNotification({
            msg: 'An error occurred while setting up price tracking. Please try again.',
            type: 'error',
          })
        } finally {
          this.submitting = false
        }
      },

      onImportSuccess() {
        // Refresh importations list and statistics when single product import is successful
        this.updateStatistics()
        this.getRequests(0, 10)
      },

      showTutorial() {
        this.$router.push('/tutorial')
      },
      getRequestsPager(payload) {
        this.getRequests(payload.from, payload.size)
      },
      showHandleErrorModal(payload) {
        this.selected_item = payload
        this.show_error_handler_modal = !this.show_error_handler_modal
        this.getErrorsInfo(payload.id)
      },
      updateStatistics() {
        axios
          .get('/api/importation/getstatistics', {
            params: {
              account_id: localStorage.getItem('account_id'),
            },
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then((res) => {
            this.inserted = res.data.inserted
            this.limit = res.data.limit
          })
          .catch(function () {
            console.log('FAILURE!! get all requests')
          })
      },
      showImportModal() {
        this.show_import_modal = !this.show_import_modal
      },
      showProductsCreationModal() {
        this.show_products_creation_modal = !this.show_products_creation_modal
      },
      getRequests(from, size) {
        axios
          .get('/api/importation', {
            params: {
              account_id: localStorage.getItem('account_id'),
              from,
              size,
            },
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then((res) => {
            this.importations = res.data
            this.updateStatistics()
          })
          .catch(function () {
            console.log('FAILURE!! get all requests')
          })
      },
      async getErrorsInfo(id, type) {
        this.errors_info = []
        this.error_id = id
        this.errors_loading = true
        axios
          .get('/api/importation/geterrorinfo', {
            params: {
              account_id: localStorage.getItem('account_id'),
              id,
            },
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then((res) => {
            this.isSingleProduct = res.data.isSingleProduct ? true : false
            this.errors_loading = false
            if (res.data.status) {
              this.errors_info = res.data.data.map((elt) => {
                elt.checked = true
                return elt
              })
            }
          })
          .catch((err) => {
            console.log('FAILURE!! get all requests', err)
          })
      },
      confirmModal(payload) {
        this.selected_item = payload
        this.modal_error_msg = payload.msg
        this.show_confirm_dialog = !this.show_confirm_dialog
      },
      confirmInsertion(confirm) {
        axios
          .post('/api/importation/confirminsertion', {
            data: {
              account_id: localStorage.getItem('account_id'),
              id: this.selected_item.id,
              type: this.selected_item.type_num,
              confirm,
            },
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then((res) => {
            this.show_confirm_dialog = false
            if (res.data.status) {
              this.showNotification({ msg: res.data.msg, type: 'success' })
            }
          })
          .catch(function () {
            console.log('FAILURE!! confirmation')
          })
      },
      blobToFile(data, filename) {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
      },
      async downloadSampleFile() {
        try {
          await this.loadXLSXLibrary()
          // eslint-disable-next-line no-undef
          const XLSX = window.XLSX

          const headers = [
            'SKU',
            'EAN',
            'NAME',
            'BRAND',
            'PRICE',
            'IMAGE',
            'MY_URL',
            'COMPETITOR_1',
            'COMPETITOR_2',
          ]
          const data = [
            [
              'ABC12345',
              '1234567890123',
              'Sample Product 1',
              'Brand A',
              '199.99',
              'https://mystore.com/image1.jpg',
              'https://mystore.com/product1',
              'https://competitor1.com/p1',
              'https://competitor2.com/p1',
            ],
            [
              'DEF67890',
              '',
              'Sample Product 2',
              'Brand B',
              '12.50',
              '',
              'https://mystore.com/product2',
              'https://competitor1.com/p2',
              '',
            ],
          ]

          const ws = XLSX.utils.aoa_to_sheet([headers, ...data])
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, ws, 'Template')

          XLSX.writeFile(wb, 'pricing_import_template.xlsx')
        } catch (error) {
          console.error('Error generating sample file:', error)
          this.showNotification({
            msg: 'Error generating template file.',
            type: 'error',
          })
        }
      },
      showNotification(payload) {
        this.snackbar_color = payload.type
        this.snackbar_msg = payload.msg
        this.snackbar = true
      },

      // File Import Methods
      removeSelectedFile() {
        this.selectedFile = null
        this.previewData = []
        this.validationResults = null
        this.convertedProducts = []
        this.fileProcessing = false
        this.showPreviewTable = false
      },

      clearFileImport() {
        this.removeSelectedFile()
        this.convertedProducts = []
        this.fileProcessing = false
        this.showPreviewTable = false
        // Reset file input
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = ''
        }
      },

      formatFileSize(bytes) {
        if (bytes === 0) return '0 Bytes'
        const k = 1024
        const sizes = ['Bytes', 'KB', 'MB', 'GB']
        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
      },

      // File Upload and Processing Methods
      triggerFileInput() {
        this.$refs.fileInput.click()
      },

      handleFileDrop(event) {
        this.isDragOver = false
        const files = event.dataTransfer.files
        if (files.length > 0) {
          this.processFile(files[0])
        }
      },

      handleFileSelect(event) {
        const file = event.target.files[0]
        if (file) {
          this.processFile(file)
        }
      },

      async processFile(file) {
        // Validate file type
        const validTypes = ['.csv', '.xlsx', '.xls']
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase()

        if (!validTypes.includes(fileExtension)) {
          this.showNotification({
            msg: 'Invalid file type. Please upload CSV or Excel files only.',
            type: 'error',
          })
          return
        }

        this.selectedFile = file
        this.fileProcessing = true
        this.previewData = []
        this.validationResults = null
        this.convertedProducts = []

        try {
          if (fileExtension === '.csv') {
            await this.processCSVFile(file)
          } else if (fileExtension === '.xlsx' || fileExtension === '.xls') {
            await this.processExcelFile(file)
          } else {
            this.showNotification({
              msg: 'Unsupported file format.',
              type: 'error',
            })
            this.fileProcessing = false
            return
          }
        } catch (error) {
          console.error('Error processing file:', error)
          this.showNotification({
            msg: 'Error processing file. Please check the format and try again.',
            type: 'error',
          })
        } finally {
          this.fileProcessing = false
        }
      },

      async processCSVFile(file) {
        const text = await this.readFileAsText(file)
        const lines = text.split('\n').filter((line) => line.trim())

        if (lines.length < 2) {
          throw new Error('File must contain headers and at least one data row')
        }

        // Parse CSV headers
        let headers = this.parseCSVLine(lines[0])
        headers = headers.map((h) => h.trim())

        const requiredColumns = ['SKU', 'MY_URL']
        const optionalColumns = ['EAN', 'NAME', 'BRAND']

        // Validate required columns
        const missingColumns = requiredColumns.filter(
          (col) => !headers.some((header) => header.toUpperCase() === col),
        )

        if (missingColumns.length > 0) {
          throw new Error(`Missing required columns: ${missingColumns.join(', ')}`)
        }

        // Process data rows (always skip empty rows)
        const rawData = []
        for (let i = 1; i < lines.length; i++) {
          if (!lines[i].trim()) continue // Always skip empty rows

          const values = this.parseCSVLine(lines[i])
          const rowData = {}

          headers.forEach((header, index) => {
            const val = values[index] || ''
            rowData[header.toLowerCase().replace(/[^a-z0-9]/g, '_')] = val.trim()
          })

          rawData.push(rowData)
        }

        // Convert to preview format and validate
        this.convertAndValidateData(rawData, headers)
      },

      async processExcelFile(file) {
        try {
          // Check if XLSX library is loaded
          if (typeof window.XLSX === 'undefined') {
            throw new Error('XLSX library not loaded. Please try again.')
          }

          // Read the file as array buffer
          const arrayBuffer = await this.readFileAsArrayBuffer(file)

          // Parse the Excel file
          const workbook = window.XLSX.read(arrayBuffer, { type: 'array' })

          // Get the first worksheet
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]

          // Convert to JSON
          const jsonData = window.XLSX.utils.sheet_to_json(worksheet, { header: 1 })

          if (jsonData.length < 2) {
            throw new Error('File must contain headers and at least one data row')
          }

          // Get headers (first row)
          const headers = jsonData[0].map((header) => String(header || '').trim())
          const requiredColumns = ['SKU', 'MY_URL']

          // Validate required columns
          const missingColumns = requiredColumns.filter(
            (col) => !headers.some((header) => header.toUpperCase() === col),
          )

          if (missingColumns.length > 0) {
            throw new Error(`Missing required columns: ${missingColumns.join(', ')}`)
          }

          // Process data rows
          const rawData = []
          for (let i = 1; i < jsonData.length; i++) {
            const row = jsonData[i]
            if (!row || row.every((cell) => !cell || String(cell).trim() === '')) continue // Skip empty rows

            const rowData = {}
            headers.forEach((header, index) => {
              rowData[header.toLowerCase().replace(/[^a-z0-9]/g, '_')] = String(
                row[index] || '',
              ).trim()
            })

            rawData.push(rowData)
          }

          // Convert to preview format and validate
          this.convertAndValidateData(rawData, headers)
        } catch (error) {
          console.error('Error processing Excel file:', error)
          throw error
        }
      },

      loadXLSXLibrary() {
        // Check if XLSX is already loaded globally
        if (typeof window.XLSX !== 'undefined') {
          return Promise.resolve(window.XLSX)
        }

        return new Promise((resolve, reject) => {
          // Create script element to load XLSX library
          const script = document.createElement('script')
          script.type = 'text/javascript'
          script.src = 'https://cdn.sheetjs.com/xlsx-0.20.3/package/dist/xlsx.full.min.js'
          script.onload = () => {
            if (typeof window.XLSX !== 'undefined') {
              console.log('XLSX library loaded successfully')
              resolve(window.XLSX)
            } else {
              reject(new Error('Failed to load XLSX library'))
            }
          }
          script.onerror = () => {
            reject(new Error('Failed to load XLSX library from CDN'))
          }

          // Add script to document head
          document.head.appendChild(script)
        })
      },

      readFileAsArrayBuffer(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = (e) => resolve(new Uint8Array(e.target.result))
          reader.onerror = (e) => reject(e)
          reader.readAsArrayBuffer(file)
        })
      },

      convertAndValidateData(rawData, headers) {
        this.previewData = []
        this.convertedProducts = []
        let validCount = 0
        let errorCount = 0
        let warningCount = 0

        rawData.forEach((row, index) => {
          try {
            const convertedProduct = this.convertRowToProduct(row, headers, index + 1)

            if (convertedProduct) {
              let status = 'success'
              let statusMessage = 'Valid product'
              let warnings = []

              // Check for warnings
              if (!convertedProduct.eanSku) {
                warnings.push('Missing EAN/SKU')
              }
              if (convertedProduct.matchsUrls.length === 0) {
                warnings.push('No competitor URLs')
              }
              if (!convertedProduct.name) {
                warnings.push('Missing product name')
              }
              if (!convertedProduct.brand) {
                warnings.push('Missing brand')
              }

              if (warnings.length > 0) {
                status = 'warning'
                statusMessage = warnings.join(', ')
                warningCount++
              } else {
                validCount++
              }

              // Add to preview data
              this.previewData.push({
                sku: convertedProduct.sku,
                my_url: convertedProduct.mainProductUrl,
                price: convertedProduct.price || '',
                ean: convertedProduct.eanSku,
                name: convertedProduct.name || '',
                brand: convertedProduct.brand || '',
                competitors: convertedProduct.matchsUrls.length,
                status: status,
                statusMessage: statusMessage,
              })

              // Add to converted products for tracking
              this.convertedProducts.push(convertedProduct)
            }
          } catch (error) {
            console.error(`Error processing row ${index + 1}:`, error)

            // Create preview entry for error row
            this.previewData.push({
              sku: row[headers.indexOf('SKU')] || '',
              my_url: row[headers.indexOf('MY_URL')] || '',
              price: row[headers.indexOf('PRICE')] || '',
              ean: row[headers.indexOf('EAN')] || '',
              name: row[headers.indexOf('NAME')] || '',
              brand: row[headers.indexOf('BRAND')] || '',
              competitors: 0,
              status: 'error',
              statusMessage: `Error: ${error.message || 'Invalid row data'}`,
            })

            errorCount++
          }
        })

        // Update validation results
        this.validationResults = {
          valid: validCount,
          warnings: warningCount,
          errors: errorCount,
        }

        //this.showNotification({
        //  msg: `File processed: ${validCount} valid products, ${errorCount} errors, ${warningCount} warnings`,
        //  type: validCount > 0 ? 'success' : 'warning'
        //});
      },

      convertRowToProduct(row, headers, rowNumber) {
        // Find column mappings (case insensitive)
        const getColumnValue = (possibleNames) => {
          for (const name of possibleNames) {
            const key = Object.keys(row).find(
              (k) =>
                k.toLowerCase().replace(/[^a-z0-9]/g, '_') ===
                name.toLowerCase().replace(/[^a-z0-9]/g, '_'),
            )
            if (key && row[key]) return row[key].trim()
          }
          return ''
        }

        const sku = getColumnValue(['sku'])
        const myUrl = getColumnValue(['my_url', 'main_url', 'product_url'])
        const price = getColumnValue(['price', 'my_price', 'product_price'])
        const image = getColumnValue(['image', 'image_url', 'img', 'product_image'])

        // Validate required fields
        if (!sku) throw new Error(`Row ${rowNumber}: SKU is required`)
        if (!myUrl) throw new Error(`Row ${rowNumber}: MY_URL is required`)
        if (!this.isValidUrl(myUrl)) throw new Error(`Row ${rowNumber}: Invalid MY_URL format`)

        // Extract optional fields
        const eanSku = getColumnValue(['ean', 'ean_sku', 'barcode'])
        const name = getColumnValue(['name', 'product_name', 'title'])
        const brand = getColumnValue(['brand', 'manufacturer'])

        // Extract competitor URLs
        const matchsUrls = []
        let competitorIndex = 1
        let competitorUrl

        // eslint-disable-next-line no-constant-condition
        while (true) {
          competitorUrl = getColumnValue([
            `competitor_${competitorIndex}`,
            `competitor${competitorIndex}`,
            `comp_${competitorIndex}`,
            `url_${competitorIndex}`,
          ])

          if (!competitorUrl) break

          if (this.isValidUrl(competitorUrl)) {
            matchsUrls.push({ matchUrl: competitorUrl })
          }

          competitorIndex++
        }

        return {
          sku: sku,
          mainProductUrl: myUrl,
          price: price,
          eanSku: eanSku,
          name: name,
          brand: brand,
          image: image,
          matchsUrls: matchsUrls,
        }
      },

      readFileAsText(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = (e) => resolve(e.target.result)
          reader.onerror = (e) => reject(e)
          reader.readAsText(file)
        })
      },

      parseCSVLine(line) {
        const result = []
        let current = ''
        let inQuotes = false

        for (let i = 0; i < line.length; i++) {
          const char = line[i]

          if (char === '"') {
            if (inQuotes && line[i + 1] === '"') {
              current += '"'
              i++ // Skip next quote
            } else {
              inQuotes = !inQuotes
            }
          } else if (char === ',' && !inQuotes) {
            result.push(current)
            current = ''
          } else {
            current += char
          }
        }

        result.push(current)
        return result
      },

      // Import converted products to tracking list
      importToTrackingList() {
        if (this.convertedProducts.length === 0) return

        let importedCount = 0

        this.convertedProducts.forEach((product) => {
          // Add product without checking for duplicates
          this.trackingList.push({
            mainProductUrl: product.mainProductUrl,
            eanSku: product.eanSku,
            matchsUrls: [...product.matchsUrls],
            name: product.name,
            price: product.price,
            brand: product.brand,
            image: product.image,
            sku: product.sku,
            user_ref: product.sku,
          })
          importedCount++
        })

        // Clear file import data
        this.clearFileImport()

        // Switch to single product tab to show imported products
        this.activeTab = 0

        this.showNotification({
          msg: `${importedCount} products imported to tracking list successfully!`,
          type: 'success',
        })
      },

      validateFileData() {
        // Mock validation results - would be replaced with actual validation logic
        this.validationResults = {
          valid: 3,
          warnings: 1,
          errors: 0,
        }
      },

      // CSV Template Generation and Download
      downloadCSVTemplate() {
        const csvContent = this.generateCSVTemplate()
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', 'product-import-template.csv')
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },

      generateCSVTemplate() {
        // Define CSV headers
        const headers = [
          'SKU',
          'MY_URL',
          'PRICE',
          'IMAGE',
          'EAN',
          'NAME',
          'BRAND',
          'COMPETITOR_1',
          'COMPETITOR_2',
        ]

        // Define sample data rows
        const sampleData = [
          [
            'ABC123',
            'https://mystore.com/headphones',
            '199.99',
            'https://mystore.com/img1.jpg',
            '1234567890123',
            'Wireless Headphones',
            'TechBrand',
            'https://amazon.com/product1',
            'https://bestbuy.com/product1',
          ],
          [
            'DEF456',
            'https://mystore.com/gaming-mouse',
            '12.50',
            '',
            '9876543210987',
            'Gaming Mouse',
            'GameCorp',
            'https://ebay.com/product2',
            'https://walmart.com/product2',
          ],
          [
            'GHI789',
            'https://mystore.com/phone-case',
            '25.00',
            'https://mystore.com/img3.jpg',
            '',
            'Smartphone Case',
            'CaseMaker',
            'https://target.com/product3',
            '',
          ],
        ]

        // Convert to CSV format
        const csvRows = []

        // Add headers
        csvRows.push(headers.join(','))

        // Add sample data
        sampleData.forEach((row) => {
          const escapedRow = row.map((field) => {
            // Escape fields that contain commas, quotes, or newlines
            if (field.includes(',') || field.includes('"') || field.includes('\n')) {
              return `"${field.replace(/"/g, '""')}"`
            }
            return field
          })
          csvRows.push(escapedRow.join(','))
        })

        return csvRows.join('\n')
      },
    },
  }
</script>

<style>
  .card-botton {
    cursor: pointer;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .theme--light.v-application {
    background: none !important;
  }
  .error-color {
    color: #f0506e;
  }

  /* Single Product Form Styles */
  .single-product-form {
    border-radius: 12px;
  }

  .competitor-urls-section {
    background: #fafafa;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #e0e0e0;
  }

  .favicon-icon {
    border-radius: 2px;
    object-fit: contain;
    margin-top: 4px;
    margin-right: 4px;
  }
  /* Custom button hover effects */
  /* .v-btn:not(.v-btn--disabled):hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.12);
  } */

  /* Smooth transitions */
  .v-text-field,
  .v-btn {
    transition: all 0.3s ease;
  }

  /* Animated button with subtle color cycling */
  .animated-button {
    animation: color-pulse 3s ease-in-out infinite;
    transition: all 0.3s ease;
  }

  .animated-button:hover {
    animation-play-state: paused;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  }

  @keyframes color-pulse {
    0%,
    100% {
      border-color: #1976d2; /* Primary blue */
      color: #1976d2;
    }
    25% {
      border-color: #00bcd4; /* Cyan */
      color: #00bcd4;
    }
    50% {
      border-color: #4caf50; /* Green */
      color: #4caf50;
    }
    75% {
      border-color: #ff9800; /* Orange */
      color: #ff9800;
    }
  }

  /* Info icon subtle pulse */
  .v-icon.mdi-information-outline {
    animation: info-glow 2s ease-in-out infinite alternate;
  }

  @keyframes info-glow {
    from {
      opacity: 0.7;
    }
    to {
      opacity: 1;
    }
  }

  /* Horizontal scrolling for tracking list */
  .tracking-list-scroll-container {
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100%;
    padding-bottom: 8px;
    margin-bottom: 8px;
  }

  .tracking-list-scroll-container::-webkit-scrollbar {
    height: 6px;
  }

  .tracking-list-scroll-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .tracking-list-scroll-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  .tracking-list-scroll-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  .tracking-list-horizontal {
    min-width: fit-content;
  }

  .tracking-item-wrapper {
    width: 280px;
    min-width: 280px;
  }

  .tracking-item-wrapper:last-child {
    margin-right: 0 !important;
  }

  .tracking-item-card {
    transition: all 0.2s ease;
  }

  .tracking-item-card:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  /* Start Tracking Button Animation */
  .tracking-button-animation {
    animation: pulse-glow 2s ease-in-out infinite;
  }

  .tracking-button-animation:hover {
    animation-play-state: paused;
  }

  @keyframes pulse-glow {
    0%,
    100% {
      transform: scale(1);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
    }
    50% {
      transform: scale(1.02);
      box-shadow:
        0 4px 8px rgba(25, 118, 210, 0.3),
        0 0 0 4px rgba(25, 118, 210, 0.1);
    }
  }

  /* File Import Styles */
  .upload-dropzone {
    border: 2px dashed #e0e0e0;
    border-radius: 12px;
    background-color: #fafafa;
    transition: all 0.3s ease;
    cursor: pointer;
  }

  .upload-dropzone:hover {
    border-color: #1976d2;
    background-color: #f3f7ff;
  }

  .upload-dropzone.dragover {
    border-color: #1976d2;
    background-color: #e3f2fd;
    transform: scale(1.02);
  }

  .upload-dropzone.processing {
    border-color: #1976d2;
    background-color: #f8f9fa;
    cursor: not-allowed;
  }

  .upload-dropzone.file-selected {
    border-color: #4caf50;
    background-color: #f1f8e9;
    cursor: default;
  }

  .gap-2 {
    gap: 8px;
  }

  .selected-file-info .v-alert {
    border-left: 4px solid #1976d2 !important;
  }

  .format-requirements .v-expansion-panel {
    border-radius: 8px !important;
  }

  .format-requirements .v-expansion-panel-header {
    min-height: 48px;
  }

  .import-configuration .v-card {
    border-radius: 8px;
  }

  .file-preview .v-data-table {
    border-radius: 8px;
  }

  .validation-results .v-alert {
    border-radius: 8px;
  }

  /* Format Requirements Styles */
  .format-info-grid .format-column-info {
    text-align: center;
    padding: 8px;
  }

  .sample-format-table {
    border-radius: 12px;
    overflow: hidden;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  .sample-format-table .v-simple-table {
    border-radius: 12px;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  .sample-format-table .sample-header th {
    background-color: #f5f5f5 !important;
    color: #1976d2 !important;
    font-weight: 600 !important;
    border-bottom: 2px solid #1976d2 !important;
    padding: 12px 8px !important;
    font-size: 0.875rem;
    position: relative;
    vertical-align: top;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  .sample-format-table .sample-header .required-column {
    background-color: #ffebee !important;
    border-bottom-color: #f44336 !important;
  }

  .sample-format-table .sample-header .optional-column {
    background-color: #f3f7ff !important;
    border-bottom-color: #2196f3 !important;
  }

  .column-requirement {
    font-size: 0.7rem !important;
    font-weight: 400 !important;
    opacity: 0.8;
    margin-top: 2px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .required-column .column-requirement {
    color: #f44336 !important;
  }

  .optional-column .column-requirement {
    color: #2196f3 !important;
  }

  .sample-format-table .sample-data {
    font-family: 'Courier New', monospace;
    font-size: 0.8rem;
    color: #424242;
    padding: 8px !important;
    border-bottom: 1px solid #e0e0e0 !important;
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  .sample-format-table tbody tr:hover {
    background-color: #f8f9fa !important;
  }

  .sample-format-table tbody tr:nth-child(even) {
    background-color: #fafafa;
  }

  /* Table Hover Overlay Styles */
  .table-container-with-overlay {
    position: relative;
  }

  .table-hover-overlay {
    opacity: 0;
    transition: opacity 0.3s ease;
    background-color: rgba(255, 255, 255, 0.95) !important;
    border-radius: 12px;
  }

  .table-container-with-overlay:hover .table-hover-overlay {
    opacity: 0.8;
  }

  .download-overlay-btn {
    text-transform: none !important;
    font-weight: 500;
    box-shadow: 0 4px 20px rgba(25, 118, 210, 0.3) !important;
  }

  .download-overlay-btn:hover {
    opacity: 0.4;
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(25, 118, 210, 0.4) !important;
  }

  /* Removed global overlay scrim styling that interferes with modals */
  /* .v-overlay__scrim{
    background-color: rgba(255, 255, 255, 0.95) !important;
    opacity: 0.5 !important;
  } */

  /* Bottom Left Download Button */
  .bottom-left-download-btn {
    position: absolute;
    bottom: 8px;
    left: 8px;
    z-index: 2;
    text-transform: none !important;
    font-size: 0.75rem !important;
    min-width: auto !important;
    padding: 4px 8px !important;
    height: 24px !important;
    border-radius: 6px !important;
    box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2) !important;
  }

  .bottom-left-download-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 12px rgba(25, 118, 210, 0.3) !important;
  }

  /* Error and Warning Text Styling */
  .error-text {
    color: #f44336 !important;
  }

  .warning-text {
    color: #ff9800 !important;
  }

  .success-text {
    color: #4caf50 !important;
  }

  /* Status Icons */
  .status-icon {
    font-size: 18px !important;
  }

  .status-icon.error {
    color: #f44336 !important;
  }

  .status-icon.warning {
    color: #ff9800 !important;
  }

  .status-icon.success {
    color: #4caf50 !important;
  }

  .validation-stats {
    margin: 0 -8px;
  }

  .validation-stat-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    border: 1px solid #f0f0f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  .validation-stat-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  }

  .stat-icon {
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #f8f9fa;
  }

  .success-card .stat-icon {
    background: rgba(76, 175, 80, 0.1);
  }

  .warning-card .stat-icon {
    background: rgba(33, 150, 243, 0.1);
  }

  .error-card .stat-icon {
    background: rgba(244, 67, 54, 0.1);
  }

  .stat-content {
    flex: 1;
  }

  .stat-number {
    font-size: 2rem;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 4px;
  }

  .success-card .stat-number {
    color: #4caf50;
  }

  .warning-card .stat-number {
    color: #2196f3;
  }

  .error-card .stat-number {
    color: #f44336;
  }

  .stat-label {
    font-size: 0.875rem;
    color: #666;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .info-message.v-alert {
    border-radius: 12px !important;
    background: rgba(33, 150, 243, 0.04) !important;
    border: 1px solid rgba(33, 150, 243, 0.12) !important;
  }

  .info-message .v-alert__wrapper {
    padding: 16px !important;
  }

  .v-application .elevation-20 {
    -webkit-box-shadow:
      0px 10px 13px -6px rgba(209, 209, 209, 0.2),
      0px 20px 31px 3px rgba(179, 179, 179, 0.14),
      0px 8px 38px 7px rgba(179, 179, 179, 0.14) !important;
    box-shadow:
      0px 10px 13px -6px rgba(202, 202, 202, 0.2),
      0px 20px 31px 3px rgba(179, 179, 179, 0.14),
      0px 8px 38px 7px rgba(179, 179, 179, 0.14) !important;
  }
</style>
